<template>
  <div class="login-container main-container">
    <img src="@/static/img/chain/nft_banner.jpg" width="100%" />
    <div class="info basic-form">
      <label>{{ $t("enter_nft_wallet") }}</label>
      <input
        type="text"
        v-model="address"
        :placeholder="$t('webwallet_address')"
        @keydown.enter="login"
      />
      <div>
        <a @click="login" :class="['btn', { disabled: loading }]">{{ $t("Confirm") }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      address: "",
      loading: false,
    };
  },
  methods: {
    async login() {
      this.loading = true;
      let address = this.address?.trim();
      if (!this.user?.isAddress(address)) {
        this.loading = false;
        return this.$toast(this.$t("invalid_address"));
      }
      if(!(await this.user?.getIsContract(address))){
        this.loading = false;
        return this.$toast(this.$t("invalid_address_on_blockchain"));
      }
      this.$router.push(`/${this.currentChain}/assets?addr=${address}`);
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.info.basic-form {
  width: 45%;
  padding-top: 24px;
  margin: 0 auto;
  text-align: left;
  color: #000;
}
</style>
